import { render } from "./DebugWindow.vue?vue&type=template&id=72a42bed&scoped=true"
import script from "./DebugWindow.vue?vue&type=script&lang=js"
export * from "./DebugWindow.vue?vue&type=script&lang=js"

import "./DebugWindow.vue?vue&type=style&index=0&id=72a42bed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a42bed"]])

export default __exports__